const MAPLIBRE_VERSION = "4.7.1";
const CSS_URL = `https://unpkg.com/maplibre-gl@${MAPLIBRE_VERSION}/dist/maplibre-gl.css`;
const JS_URL = `https://unpkg.com/maplibre-gl@${MAPLIBRE_VERSION}/dist/maplibre-gl.js`;

let loading = null;

function injectCss(href) {
  if (document.querySelector(`link[data-qeja-maplibre="1"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.dataset.qejaMaplibre = "1";
  document.head.appendChild(link);
}

function injectScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[data-qeja-maplibre="1"]`);
    if (existing) {
      if (window.maplibregl) return resolve(window.maplibregl);
      existing.addEventListener("load", () => resolve(window.maplibregl));
      existing.addEventListener("error", () => reject(new Error("MapLibre failed to load")));
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.dataset.qejaMaplibre = "1";
    script.onload = () => resolve(window.maplibregl);
    script.onerror = () => reject(new Error("MapLibre failed to load"));
    document.head.appendChild(script);
  });
}

/** Prefetch or fully load MapLibre GL (CDN). Safe to call repeatedly. */
export function loadMapLibre() {
  if (typeof window !== "undefined" && window.maplibregl) {
    return Promise.resolve(window.maplibregl);
  }
  if (loading) return loading;
  injectCss(CSS_URL);
  loading = injectScript(JS_URL).then((gl) => {
    if (!gl) throw new Error("MapLibre global missing after load");
    return gl;
  });
  return loading;
}

/** Warm the CDN cache without initializing a map. */
export function prefetchMapLibre() {
  if (typeof window === "undefined" || window.maplibregl || loading) return;
  injectCss(CSS_URL);
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "script";
  link.href = JS_URL;
  link.dataset.qejaMaplibrePreload = "1";
  document.head.appendChild(link);
}
